import React from "react";
import PropTypes from "prop-types";
import DynamicIcons from "../DynamicIcons";

export default function CardStats({
  statSubtitle,
  statSubtitleTitle,
  styles,
  statTitle,
  statPercent,
  titleDescription,
  statDescripiron,
  statDescripironTitle,
  statIconName,
  statIconColor,
  onClickFirst,
  onClickSecond,
}) {
  return (
    <>
      <div className={`relative flex flex-col min-w-0 w-full break-words ${styles}`} onClick={onClickSecond}>
        <div className="flex-auto  pb-4 px-2">
          <div className="flex ">
            <div className="w-full items-center flex justify-between ">
              <span className="text-blue font-[500] text-[3rem]">
                {statSubtitle}
              </span>
              { statIconName && statIconColor ? (
                <div
                className={
                  "text-white  text-center inline-flex items-center justify-center w-12 h-12  rounded-full " +
                  statIconColor
                }
              >
                <DynamicIcons iconName={statIconName} />
              </div>
              ): (<div></div>) }
              
            </div>
          </div>
          <div className="relative w-auto flex-initial">
            <p className="text-lg font-bolder">{statSubtitleTitle}</p>
          </div>
          <div className="flex justify-between mt-2">
            <div className="cursor-pointer" onClick={onClickSecond}>
              <span className={"text-green-500 mr-1 "}>
                {statTitle}
              </span>
              <span className="text-blueGray-400 text-sm">{statDescripiron}</span>
            </div>
            {statPercent ? (<div className="cursor-pointer" onClick={onClickSecond}>
              <span className={"text-gray-500 mr-1 "}>
                {statPercent}
              </span>
              <span className="text-blueGray-400 text-sm">{statDescripironTitle}</span>
            </div>) : ""}
          </div>
        </div>
      </div>
    </>
  );
}

CardStats.defaultProps = {
  statSubtitle: "Traffic",
  statTitle: "350,897",
  statArrow: "up",
  statPercent: "3.48",
  statPercentColor: "text-emerald-500",
  statDescripiron: "Since last month",
  //statIconName: "far fa-chart-bar",
  //statIconColor: "bg-red-500",
};

CardStats.propTypes = {
  statSubtitle: PropTypes.string,
  statTitle: PropTypes.string,
  statArrow: PropTypes.oneOf(["up", "down"]),
  statPercent: PropTypes.string,
  // can be any of the text color utilities
  // from tailwindcss
  statPercentColor: PropTypes.string,
  statDescripiron: PropTypes.string,
  statIconName: PropTypes.string,
  // can be any of the background color utilities
  // from tailwindcss
  statIconColor: PropTypes.string,
};
